import { HELP_ARTICLES } from "./articles";
import { searchHelp, type HelpSearchHit } from "./search";
import { isKnowledgeObject } from "@/lib/public-knowledge-template";

export interface HelpSearchView {
  query: string;
  hits: HelpSearchHit[];
}
export function buildHelpSearchView(query: string): HelpSearchView {
  const normalized = query.trim();
  return { query: normalized, hits: normalized ? searchHelp(HELP_ARTICLES, normalized) : [] };
}
export function isHelpSearchView(value: unknown): value is HelpSearchView {
  return isKnowledgeObject(value) && typeof value.query === "string" &&
    Array.isArray(value.hits) && value.hits.every(hit => isKnowledgeObject(hit) &&
      typeof hit.score === "number" && Number.isFinite(hit.score) &&
      isKnowledgeObject(hit.article) && ["slug", "topic", "title", "summary"]
        .every(key => typeof (hit.article as Record<string, unknown>)[key] === "string") &&
      Array.isArray(hit.article.body));
}
